import React, { useState } from 'react';
import { Gift, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const eur = (v) => `${Number(v || 0).toFixed(2).replace('.', ',')} €`;

/* Boutique portail : le client active son bon cadeau → le montant est crédité sur son compte. */
export const GiftCardActivateCard = ({ token, onActivated }) => {
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);

  const activate = async () => {
    if (!code.trim()) return;
    setBusy(true);
    try {
      const r = await fetch(`${API_URL}/api/pos/gift-cards/portal/redeem`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: code.trim() }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(typeof d?.detail === 'string' ? d.detail : 'Activation impossible');
      toast.success(`Bon ${d.gift_card_number} activé : ${eur(d.amount_credited)} crédités sur votre compte`);
      setCode('');
      onActivated?.(d.balance);
    } catch (e) {
      toast.error(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rounded-2xl p-4 space-y-2.5" style={{ backgroundColor: 'rgba(255,255,255,0.92)', boxShadow: '0 2px 12px rgba(0,0,0,0.06)' }} data-testid="gift-activate-card">
      <div className="flex items-center gap-2.5">
        <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#FBF3DC' }}>
          <Gift size={18} style={{ color: '#B8860B' }} />
        </div>
        <div>
          <p className="text-sm font-bold text-neutral-900">Activer mon bon cadeau</p>
          <p className="text-[11px] text-neutral-500">Saisissez le code du bon : son montant est crédité sur votre compte</p>
        </div>
      </div>
      <div className="flex gap-2">
        <input value={code} onChange={e => setCode(e.target.value.toUpperCase())} onKeyDown={e => e.key === 'Enter' && activate()}
          placeholder="CODE DU BON" autoCapitalize="characters" className="flex-1 min-w-0 h-10 border rounded-lg px-3 text-sm font-mono tracking-widest uppercase"
          data-testid="gift-activate-code-input" />
        <button type="button" onClick={activate} disabled={busy || !code.trim()} className="h-10 px-4 rounded-lg text-white text-sm font-semibold disabled:opacity-50 flex items-center gap-1.5"
          style={{ backgroundColor: '#B8860B' }} data-testid="gift-activate-btn">
          {busy ? <Loader2 size={14} className="animate-spin" /> : null} Activer
        </button>
      </div>
    </div>
  );
};
